import { jsx as _jsx } from "react/jsx-runtime";
import { IrbStatus } from 'libs.irb.common';
import { FormattedDateTime } from 'libs.react';
import { StatusCell, ActionCell } from './cell-components';
// Stable cell renderer functions
export const statusCellRenderer = ({ getValue }) => {
    const status = getValue();
    return _jsx(StatusCell, { status: status });
};
export const actionCellRenderer = ({ row }) => {
    const { status, locale, fileName } = row.original;
    const { url, errorMessage } = row.original.action || {};
    return _jsx(ActionCell, { status: status, locale: locale, url: url, errorMessage: errorMessage, fileName: fileName });
};
export const optionsCellRenderer = ({ row }) => {
    const { options } = row.original;
    return _jsx("div", { children: options.join(', ') });
};
export const creationDateCellRenderer = ({ row }) => {
    return row.original.createdAt ? (_jsx("div", { className: 'min-w-32', children: _jsx(FormattedDateTime, { date: row.original.createdAt }) })) : ('—');
};
// Status sorting function
export const statusSortingFn = (rowA, rowB) => {
    const statusA = rowA.original?.status;
    const statusB = rowB.original?.status;
    const createdAtA = rowA.original?.createdAt;
    const createdAtB = rowB.original?.createdAt;
    const getStatusPriority = (status) => {
        switch (status) {
            case IrbStatus.SUCCESS:
                return 0; // Highest priority
            case IrbStatus.PROCESSING:
                return 1; // Second priority
            case IrbStatus.FAILURE:
                return 2; // Third priority
            case IrbStatus.ENQUEUED:
                return 3; // Fourth priority
            default:
                return 4; // Lowest priority for undefined or other statuses
        }
    };
    const priorityA = getStatusPriority(statusA);
    const priorityB = getStatusPriority(statusB);
    if (priorityA !== priorityB) {
        return priorityA - priorityB;
    }
    // Secondary sort: most recent first
    if (createdAtA && createdAtB) {
        const timeA = createdAtA instanceof Date ? createdAtA.getTime() : new Date(createdAtA).getTime();
        const timeB = createdAtB instanceof Date ? createdAtB.getTime() : new Date(createdAtB).getTime();
        return timeB - timeA;
    }
    // Handle cases where one or both dates are missing
    if (createdAtA && !createdAtB) {
        return -1;
    } // A has date, B doesn't - A comes first
    if (!createdAtA && createdAtB) {
        return 1;
    } // B has date, A doesn't - B comes first
    return 0;
};
